import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import api from '../../services/api'
import toast from 'react-hot-toast'
import MixLogo from '../../components/MixLogo'

export default function Login() {
  const { loginUsuario } = useAuth()
  const navigate = useNavigate()
  const [form, setForm] = useState({ email: '', password: '' })
  const [cargando, setCargando] = useState(false)
  const [error, setError] = useState('')
  const [showPass, setShowPass] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setError(''); setCargando(true)
    try {
      const { data } = await api.post('/auth/login', form)
      loginUsuario(data)
      toast.success(`¡Hola ${data.usuario.nombre}!`)
      navigate('/inbox')
    } catch (err) {
      setError(err.response?.data?.error || 'Credenciales incorrectas')
    } finally {
      setCargando(false)
    }
  }

  return (
    <div style={{ display: 'flex', height: '100vh', fontFamily: "'Inter', sans-serif" }}>

      {/* ── Panel izquierdo — branding ── */}
      <div className="login-left" style={{
        padding: '48px 56px',
        background: 'linear-gradient(145deg, #075E54 0%, #128C7E 40%, #25D366 80%, #0ea5e9 100%)',
        position: 'relative', overflow: 'hidden',
      }}>
        {/* Círculos decorativos */}
        <div style={{ position: 'absolute', top: -100, right: -100, width: 360, height: 360, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
        <div style={{ position: 'absolute', bottom: -80, left: -80, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,0.06)' }} />
        <div style={{ position: 'absolute', top: '40%', left: -60, width: 180, height: 180, borderRadius: '50%', background: 'rgba(167,139,250,0.12)' }} />

        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: 340 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, justifyContent: 'center', marginBottom: 48 }}>
            <MixLogo size={48} />
            <span style={{ fontSize: 32, fontWeight: 900, color: 'white', letterSpacing: '-0.03em' }}>MixCRM</span>
          </div>

          <h2 style={{ fontSize: 28, fontWeight: 800, color: 'white', lineHeight: 1.2, marginBottom: 16 }}>
            Automatiza tus ventas por WhatsApp
          </h2>
          <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.7)', lineHeight: 1.7, marginBottom: 48 }}>
            Gestiona múltiples números, activa la IA y cierra más ventas con tu equipo en un solo panel.
          </p>

          {/* Feature bullets */}
          {[
            { icon: '🤖', text: 'Chatbot IA con Google Gemini' },
            { icon: '💬', text: 'Inbox unificado en tiempo real' },
            { icon: '📊', text: 'Pipeline Kanban drag & drop' },
          ].map((f, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: 12,
              background: 'rgba(255,255,255,0.1)', borderRadius: 12, padding: '12px 16px',
              marginBottom: 10, textAlign: 'left', backdropFilter: 'blur(4px)',
              border: '1px solid rgba(255,255,255,0.12)',
            }}>
              <span style={{ fontSize: 20 }}>{f.icon}</span>
              <span style={{ fontSize: 14, fontWeight: 500, color: 'rgba(255,255,255,0.9)' }}>{f.text}</span>
            </div>
          ))}
        </div>

        <div style={{ position: 'absolute', bottom: 32, left: 0, right: 0, textAlign: 'center', fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>
          mixcrm.click
        </div>
      </div>

      {/* ── Panel derecho — formulario ── */}
      <div className="login-right" style={{ background: '#fafafa' }}>
        <div className="login-form-wrap" style={{ width: '100%', maxWidth: 400, animation: 'fadeInUp 0.4s ease' }}>
          {/* Cabecera mobile (solo visible en mobile) */}
          <div className="login-mobile-brand">
            <MixLogo size={36} />
            <span>MixCRM</span>
          </div>
          <div style={{ marginBottom: 36, padding: '0 0' }}>
            <h2 style={{ fontSize: 26, fontWeight: 800, color: '#111827', marginBottom: 8 }}>
              Bienvenido de nuevo
            </h2>
            <p style={{ fontSize: 14, color: '#6b7280' }}>
              Ingresa a tu cuenta de MixCRM para continuar
            </p>
          </div>

          <form onSubmit={submit}>
            <div style={{ marginBottom: 18 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                Correo electrónico
              </label>
              <input
                className="input"
                type="email"
                required
                value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })}
                placeholder="tu@empresa.com"
                style={{ fontSize: 15, padding: '11px 14px' }}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                Contraseña
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  className="input"
                  type={showPass ? 'text' : 'password'}
                  required
                  value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  placeholder="••••••••"
                  style={{ fontSize: 15, padding: '11px 44px 11px 14px' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 17, color: '#9ca3af' }}
                >
                  {showPass ? '🙈' : '👁'}
                </button>
              </div>
            </div>

            <button
              className="btn btn-primary btn-block"
              disabled={cargando}
              style={{ padding: '13px 20px', fontSize: 15, borderRadius: 10, marginBottom: 12 }}
            >
              {cargando
                ? <span style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                    <span className="spinner" style={{ width: 18, height: 18, borderWidth: 2 }} />
                    Entrando...
                  </span>
                : 'Iniciar sesión →'}
            </button>

            {error && (
              <div style={{ color: '#dc2626', fontSize: 13, textAlign: 'center', marginTop: 8, padding: '10px 14px', background: '#fef2f2', borderRadius: 8, border: '1px solid #fecaca' }}>
                {error}
              </div>
            )}
          </form>

          <p style={{ textAlign: 'center', marginTop: 32, fontSize: 12, color: '#9ca3af' }}>
            <a href="/admin/login" style={{ color: '#9ca3af', textDecoration: 'none' }}>
              Acceso de administrador SaaS →
            </a>
          </p>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  )
}
